import React from "react";
import "animate.css";
import "./DataCenters.css";

function DataCenters() {
  return (
    <>
      {/* Hero Banner */}
      <div className="container-fluid bg-breadcrumb13">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Data Center Solutions
          </h4>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">

        {/* Section 3 */}
        <section className="wow fadeInUp" data-wow-delay="0.4s">
          <div className="row align-items-center mb-5 flex-column-reverse flex-lg-row-reverse">

            <div className="col-lg-6">
              <img
                src="assets/img/Datacenter1.png"
                alt="Modern Data Centers"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>

            <div className="col-lg-6">
              <div className="section-title">
                <h2>
                  Modern Data Centers: The Foundation of the Digital Economy
                </h2>

                <p>
                  Modern data centers are the foundation of today's digital economy, enabling cloud computing, artificial intelligence (AI), big data analytics, enterprise applications, and mission-critical business operations. As organizations accelerate digital transformation initiatives, the demand for secure, scalable, and resilient data center infrastructure continues to grow.
                  From supporting AI-driven workloads and hybrid cloud environments to ensuring business continuity and operational efficiency, modern data centers have evolved into strategic assets that power innovation and business growth.
                  At Celersoft, we help organizations design, optimize, and modernize enterprise data center infrastructure that supports current business demands while preparing for future technological advancements.

                </p>

                {/* <h5>The Evolving Landscape</h5>

                <ul>
                  <li>
                    <strong>$600B–$700B Global Market by 2030</strong> —
                    Historic growth driven by AI adoption, cloud migration,
                    and digital transformation.
                  </li>

                  <li>
                    <strong>Power is the #1 Growth Constraint</strong> —
                    Rack densities, liquid cooling, and thermal engineering
                    are becoming industry standards.
                  </li>

                  <li>
                    <strong>$1T+ Global Investment by 2029</strong> —
                    Massive capital flowing into AI-optimized facilities and
                    distributed edge data centers.
                  </li>
                </ul> */}


              </div>
            </div>

          </div>
        </section>
        <section>

          <div className="row">

            {/* LEFT CARDS */}
            <div className="col-md-6">
              <h3 className="fw-bold mb-4">
                The Evolving Landscape
              </h3>
              <div className="row g-3">

                <div className="col-6">

                  <div
                    className="border rounded-4 p-3 shadow-sm h-100"
                    style={{
                      background: "#f3f8ff",
                      minHeight: "210px"
                    }}
                  >
                    <h5
                      className="fw-bold"
                      style={{ color: "#46b6e8" }}
                    >
                      $600B–$700B Global Market
                    </h5>

                    <p className="small text-dark mb-0">
                      Historic growth driven by AI,
                      cloud migration, and digital transformation.
                    </p>
                  </div>
                </div>

                <div className="col-6">
                  <div
                    className="border rounded-4 p-3 shadow-sm h-100"
                    style={{
                      background: "#f3f8ff",
                      minHeight: "210px"
                    }}
                  >
                    <h5
                      className="fw-bold"
                      style={{ color: "#46b6e8" }}
                    >
                      Power is the #1 Constraint
                    </h5>

                    <p className="small text-dark mb-0">
                      Rack densities, liquid cooling,
                      and thermal engineering
                      are becoming standards.
                    </p>
                  </div>
                </div>

                <div className="col-12">
                  <div
                    className="border rounded-4 p-3 shadow-sm"
                    style={{
                      background: "#f3f8ff"
                    }}
                  >
                    <h5
                      className="fw-bold"
                      style={{ color: "#46b6e8" }}
                    >
                      $1T+ Global Investment by 2029
                    </h5>

                    <p className="small text-dark mb-0">
                      Massive investment into
                      AI-optimized facilities and
                      distributed edge data centers.
                    </p>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT IMPACT */}
            <div className="col-md-6">

              <h3 className="fw-bold mb-4">
                Strategic Business Impact
              </h3>

              <div className="d-flex mb-4">
                <span className="me-3 fs-3">🛡️</span>

                <div>
                  <h6 className="fw-bold">
                    Resilience Through Redundancy
                  </h6>

                  <p className="small text-dark mb-0">
                    Business continuity depends on resilient infrastructure. Redundant power systems, backup networks, disaster recovery capabilities,
                    and failover architectures help organizations minimize downtime and maintain uninterrupted operations.
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <span className="me-3 fs-3">📈</span>

                <div>
                  <h6 className="fw-bold">
                    Infrastructure as Strategic Enablement
                  </h6>

                  <p className="small text-dark mb-0">
                    A well-designed data center infrastructure supports business agility,
                    cloud adoption, digital innovation, and operational efficiency.
                    By aligning infrastructure investments with strategic goals, organizations can improve
                    performance while supporting future growth.
                  </p>
                </div>
              </div>

              <div className="d-flex">
                <span className="me-3 fs-3">⚠️</span>

                <div>
                  <h6 className="fw-bold">
                    Risk of Inadequate Design
                  </h6>

                  <p className="small text-dark mb-0">
                    Poor planning leads to inefficiency, unreliability and sunstantial long term maintainance costs

                  </p>
                </div>
              </div>

            </div>

          </div>
        </section> <br></br>
        <br></br>

        {/* Section 1 */}
        <section className="wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <img
                src="assets/img/Data_infra.png"
                alt="Data Center Foundation"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>

            <div className="col-lg-6">
              <div className="section-title">
                <h2>Infrastructure is Strategic Business Enablement</h2>

                <p>
                  Modern data centers are the backbone of the digital economy,
                  positioned at the critical intersection of performance,
                  security, and exponential growth.
                </p>

                <p>
                  Strategic infrastructure planning enables enterprises to
                  improve performance, ensure compliance, and create scalable
                  environments capable of supporting future workloads.
                </p>

                {/* <h5 className="mt-4">The Foundation Model</h5>

                <ul>
                  <li>
                    <strong>Performance:</strong> High-speed, low-latency
                    enterprise compute.
                  </li>

                  <li>
                    <strong>Security:</strong> Controlled, compliant physical
                    and logical environments.
                  </li>

                  <li>
                    <strong>Scalability:</strong> Infrastructure that grows
                    workloads without disruption.
                  </li>

                  <li>
                    <strong>Resilience:</strong> Multi-region redundancy and
                    seamless disaster recovery.
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        </section>




        {/* Section 4 */}


        {/* Lifecycle Process */}
        <section className="py-5 wow fadeInUp" data-wow-delay="0.5s">
          <div className="container">

            {/* Heading outside */}
            <h2
              className="fw-bold mb-4"
              style={{
                fontSize: "30px",
                color: "#111"
              }}
            >
              The Lifecycle Process
            </h2>

            <div className="row g-0">

              {[
                {
                  icon: "⚙️",
                  title: "Needs Analysis",
                  desc:
                    "Collaboration to map current and future capacity projections."
                },
                {
                  icon: "🌐",
                  title: "Site Selection",
                  desc:
                    "Optimizing location for power availability and fiber connectivity."
                },
                {
                  icon: "📐",
                  title: "Design",
                  desc:
                    "Blueprinting layout optimization, advanced thermal engineering, and security."
                },
                {
                  icon: "🤝",
                  title: "Vendor Selection",
                  desc:
                    "Trusted advisor negotiating contracts and enforcing standards."
                },
                {
                  icon: "📋",
                  title: "Project Management",
                  desc:
                    "Overseeing flawless, accountable execution to go-live."
                }
              ].map((item, index) => (
                <div
                  className="col-lg col-md-6 col-12 text-center"
                  key={index}
                >

                  {/* Arrow Shape */}
                  <div
                    style={{
                      position: "relative",
                      background: "#082b55",
                      height: "65px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      marginRight: index !== 4 ? "8px" : "0",
                      clipPath:
                        index === 0
                          ? "polygon(0 0, 88% 0, 100% 50%, 88% 100%, 0 100%, 10% 50%)"
                          : "polygon(0 0, 88% 0, 100% 50%, 88% 100%, 0 100%, 10% 50%)",
                      borderRight:
                        index !== 10
                          ? "6px solid #d26d42"
                          : "none"
                    }}
                  >
                    <span
                      style={{
                        fontSize: "42px"
                      }}
                    >
                      {item.icon}
                    </span>
                  </div>

                  {/* Text below */}
                  <div className="px-3 pt-3">
                    <h5
                      className="fw-bold mb-2"
                      style={{
                        fontSize: "22px"
                      }}
                    >
                      {item.title}
                    </h5>

                    <p
                      className="text-muted"
                      style={{
                        fontSize: "16px",
                        lineHeight: "1.5"
                      }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* Section 6 */}
        {/* Value Alignment Matrix */}
        <section className="py-5">
          <div className="container">

            <div className="text-center mb-5">
              <h2
                className="fw-bold"
                style={{
                  color: "#0a2c64",
                  fontSize: "30px"
                }}
              >
                Value Alignment Matrix
              </h2>

              <p
                className="text-dark"
                style={{ maxWidth: "700px", margin: "0 auto" }}
              >
                Delivering scalable, resilient, and future-ready
                data center ecosystems through deep expertise
                and strategic execution.
              </p>
            </div>

            <div className="row g-4">

              {/* CARD 1 */}
              <div className="col-lg-6">
                <div className="value-card h-100">

                  <div className="icon-box">
                    🏆
                  </div>

                  <h3>Seasoned Expertise</h3>

                  <p>
                    Deep industry experience executing
                    complex designs across diverse sectors.
                  </p>

                  <div className="gradient-line"></div>
                </div>
              </div>

              {/* CARD 2 */}
              <div className="col-lg-6">
                <div className="value-card h-100">

                  <div className="icon-box">
                    🌐
                  </div>

                  <h3>Rich Vendor Resources</h3>

                  <p>
                    Unlocking access to state-of-the-art
                    hardware and advanced cooling technologies.
                  </p>

                  <div className="gradient-line"></div>
                </div>
              </div>

              {/* CARD 3 */}
              <div className="col-lg-6">
                <div className="value-card h-100">

                  <div className="icon-box">
                    🗣️
                  </div>

                  <h3>Multi-lingual Engineers</h3>

                  <p>
                    Ensuring seamless global collaboration
                    and friction-free stakeholder communication.
                  </p>

                  <div className="gradient-line"></div>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="col-lg-6">
                <div className="value-card h-100">

                  <div className="icon-box">
                    🚀
                  </div>

                  <h3>Future-Proof Scalability</h3>

                  <p>
                    Designing ultra-dense,
                    AI-optimized facilities ready
                    for tomorrow’s growth.
                  </p>

                  <div className="gradient-line"></div>
                </div>
              </div>

            </div>
          </div>

        </section>
        <section className="wow fadeInUp" data-wow-delay="0.4s">
          <h3>Why Choose Celersoft for Data Center Consulting?</h3>
          <p>Celersoft provides comprehensive data center consulting services,
            helping organizations build scalable, secure, and resilient digital infrastructure environments.
            Our expertise spans infrastructure assessment,
            capacity planning, data center design, modernization, and implementation support.</p>
          <h5>Our Expertise</h5>
          <ul style={{ marginBottom: -30, padding: "0% 1% 1% 1" }}>
            <li style={{ lineHeight: 1.6 }}>
              Data Center Strategy & Consulting
            </li>
            <li style={{ lineHeight: 1.6 }}>
              Enterprise Data Center Design Services
            </li>
            <li style={{ lineHeight: 1.6 }}>Capacity Planning & Infrastructure Assessment</li>
            <li style={{ lineHeight: 1.6 }}>	Site Selection & Power Availability Analysis</li>
            <li style={{ lineHeight: 1.6 }}>	Data Center Modernization</li>
            <li style={{ lineHeight: 1.6 }}>	Infrastructure Optimization</li>
            <li style={{ lineHeight: 1.6 }}>	Project Management & Implementation</li>
            <li style={{ lineHeight: 1.6 }}>  Future-Ready Infrastructure Planning</li>


          </ul>

        </section>
        {/* PARTNER */}
      <section className="py-5">
        <div className="container">

  <div className="row align-items-center g-5">

    <div className="col-lg-5">

      <img
        src="assets/img/partner.png"
        alt="Partnership"
        className="img-fluid rounded-4 shadow"
        style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: 24
                  }}
      />

    </div>

    <div className="col-lg-7">

      <span className="private-tag">
        Partner with Celersoft
      </span>

      <h2 className="private-title mt-2">
        Build Future-Ready Connectivity
      </h2>

      <p className="private-text">
        Celersoft provides end-to-end Private 5G services and solutions, from network design and
         deployment to integration and ongoing support. Our experts help organizations build 
         future-ready connectivity platforms that enable smarter operations, stronger security,
         and sustainable business growth.
      </p>

    </div>

  </div>

</div>
      </section>
      </div>

      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>


  );
}

export default DataCenters;